import validate from 'lib/utils/validationRules';
import { formatAmount } from 'lib/utils/amount';

// Сервис для работы с tilda параметрами
const TildaParamsService = {

  // Если в json присутствует номер заказа тильды
  checkTildaOrderId(json) {
    const data = JSON.parse(json);

    if (!validate.isObjectWithFields(data, ['orderId'])) {
      return false;
    }

    return validate.isPositiveNumber(data.orderId);
  },

  // Получение параметров тильды
  getTildaParams(json) {
    const data = JSON.parse(json);

    return {
      amount: data.amount,
      details: {
        customFields: TildaParamsService.getTildaCustomFields(data.details),
        products: TildaParamsService.getTildaProducts(data.details),
        techFields: TildaParamsService.getTildaTechFields(data.details),
      },
      email: data.email || null,
      name: data.name || null,
      orderId: data.orderId,
      phone: data.phone || null,
    };
  },

  // Получение кастомных полей из тильда заказа
  getTildaCustomFields(json) {
    return JSON.parse(json.customFields);
  },

  // Получение списка товаров из тильда заказа
  getTildaProducts(json) {
    const products = JSON.parse(json.products);

    return products.map(product => {
      return {
        ...product,
        amount: parseInt(product.amount, 10),
        quantity: parseInt(product.quantity, 10),
        price: formatAmount(parseInt(product.price, 10)),
      };
    });
  },

  // Получение технических полей из тильда заказа
  getTildaTechFields(json) {
    return JSON.parse(json.techFields);
  },

  // Получение токена для оплаты установочного платежа
  getSubscriptionTokenBinding(json) {
    const data = JSON.parse(json);

    if (!validate.isObjectWithFields(data, ['subscription_token_binding'])) {
      return false;
    }

    return data.subscription_token_binding;
  },
};

export default TildaParamsService;
